module.exports = __webpack_public_path__ + "static/media/tdmns_logo.bec08f34.png";